import CurrentRefinements from '../components/Search/CurrentRefinements';
import { InstantSearch } from 'react-instantsearch-dom';
import Layout from '../components/shared/Layout';
import PageTitle from '../components/shared/PageTitle';
import React from 'react';
import ShortMovieFilters from '../components/ShortMovie/ShortMovieFilters';
import ShortMoviesHits from '../components/ShortMovie/ShortMoviesHits';
import algoliasearch from 'algoliasearch';
import { useRouter } from 'next/router';

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY,
);
const ShortMoviesHomePage: React.FunctionComponent = () => {
  const { locale } = useRouter();
  const indexName = `${process.env.NODE_ENV}_short-movies-${locale}`;
  return (
    <Layout>
      <div className="container">
        <div>
          <div className="px-4 mb-3 md:text-left text-center">
            <PageTitle>Courts métrages</PageTitle>
          </div>
          <div className="">
            <InstantSearch indexName={indexName} searchClient={searchClient}>
              <div className="flex justify-between border-t border-b border-mulled-wine text-base text-selago font-bold px-4 mb-3">
                <ShortMovieFilters />
                {/* <LanguageSwitcher /> */}
              </div>
              <CurrentRefinements />
              <div className="container px-2">
                <ShortMoviesHits />
              </div>
            </InstantSearch>
          </div>
        </div>
        {/* Image */}
      </div>
    </Layout>
  );
};

export default ShortMoviesHomePage;
